import React from "react";
import { X } from "lucide-react";

export default function AdminModal({ title, onClose, children }) {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" data-testid="admin-modal">
      <div className="absolute inset-0 bg-navy/60" onClick={onClose} />
      <div className="relative max-h-[88vh] w-full max-w-lg overflow-y-auto rounded-2xl bg-white p-6 shadow-2xl">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="font-display text-xl font-bold text-navy">{title}</h3>
          <button onClick={onClose} aria-label="Close"><X className="text-navy" /></button>
        </div>
        {children}
      </div>
    </div>
  );
}
